<template>
  <div class="speechapp">
    <van-tabs
      v-model="active"
      :lazy-render="false"
      sticky
      color="#333333"
      line-width="32"
      line-height="2"
    >
      <van-tab title="标准话术" name="standard"></van-tab>
      <van-tab title="个人话术" name="person"></van-tab>
    </van-tabs>
    <div v-if="active === 'standard'" class="standard">
      <div class="head">
        <div class="search-box">
          <div class="left">
            <van-search
              v-model="keyWord1"
              placeholder="请输入关键字"
              :maxlength="30"
              @search="onSearch"
              @clear="onSearch"
            >
              <template #left-icon>
                <img src="@/assets/img/material/icon_select.png" alt="" />
              </template>
            </van-search>
          </div>
          <img
            v-if="!showOverlay"
            style="width: 20px; height: 20px; cursor: pointer;"
            src="@/assets/img/material/icon_filter.png"
            alt=""
            @click="onOpenFilter"
          />
          <img
            v-else
            style="width: 20px; height: 20px; cursor: pointer;"
            src="@/assets/img/material/icon_filter1.png"
            alt=""
            @click="onOpenFilter"
          />
        </div>
        <div v-if="showOverlay" class="popup-tags">
          <van-tabs
            v-model="tabActive"
            :lazy-render="false"
            sticky
            color="#333333"
            line-width="32"
            line-height="2"
          >
            <van-tab
              :title="
                groupIdList.length > 0 ? `分组(${groupIdList.length})` : '分组'
              "
            >
              <div
                v-for="item in groupList"
                :key="item.groupId"
                class="tag-item"
              >
                <div class="tag-cont">
                  <div class="tags-title">{{ item.groupName }}</div>
                  <div class="tags-list">
                    <div
                      class="tags-item"
                      :class="groupIdList.includes(item.groupId) ? 'act' : ''"
                      @click="checkGroup(item)"
                    >
                      全部
                    </div>
                    <div
                      v-for="x in item.childPath"
                      :key="x.groupId"
                      class="tags-item"
                      :class="groupIdList.includes(x.groupId) ? 'act' : ''"
                      @click="checkGroup(x)"
                    >
                      {{ x.groupName }}
                    </div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab
              :title="
                tagIdList.length > 0 ? `标签(${tagIdList.length})` : '标签'
              "
            >
              <div
                v-for="item in tagList"
                :key="item.tagGroupId"
                class="tag-item"
              >
                <div v-if="item.tagList.length > 0" class="tag-cont">
                  <div class="tags-title">{{ item.tagGroupName }}</div>
                  <div class="tags-list">
                    <div
                      v-for="x in item.tagList"
                      :key="x.tagId"
                      class="tags-item"
                      :class="tagIdList.includes(x.tagId) ? 'act' : ''"
                      @click="checkTag(x)"
                    >
                      {{ x.tagName }}
                    </div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
          <div class="reset" @click="resetTags">重置</div>
        </div>
        <van-overlay :show="showOverlay" @click="handleOverlay" />
      </div>
      <div class="cont">
        <van-list
          v-model="loading"
          :finished="finished"
          :offset="400"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="item in standardList"
            :key="item.id"
            class="speech-item"
            @click="sendPersonal(item)"
          >
            <div class="title">{{ item.title }}</div>
            <div class="txt">
              {{ item.content }}
            </div>
            <div class="bot">
              <div class="num">转发量{{ item.forwardCount }}</div>
              <div class="btn" @click.stop="editStandard(item)">编辑</div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div v-if="active === 'person'" class="person">
      <div class="head">
        <div class="search-box">
          <van-search
            v-model="keyWord2"
            placeholder="请输入关键字"
            :maxlength="30"
            @search="onSearchPersonal"
            @clear="onClearPersonal"
          >
            <template #left-icon>
              <img src="@/assets/img/material/icon_select.png" alt="" />
            </template>
          </van-search>
        </div>
      </div>
      <div class="cont">
        <div
          v-for="item in personalList"
          :key="item.id"
          class="person-item"
          @click="sendPersonal(item)"
        >
          <div class="title">{{ item.title }}</div>
          <div class="txt">
            {{ item.content }}
          </div>
          <div class="bot">
            <div class="btn" @click.stop="goEdit(item)">编辑</div>
            <div class="btn" @click.stop="deletePersonal(item)">删除</div>
          </div>
        </div>
      </div>
      <img
        class="create-btn"
        :style="isWorkbenches ? { bottom: '100px' } : ''"
        src="@/assets/img/material/icon_create.png"
        alt=""
        @click="$router.push('/createAndEdit')"
      />
    </div>
    <!-- 更多面板 -->
    <van-popup
      v-model="showPopup"
      closeable
      position="bottom"
      round
      :style="{ height: '55%' }"
      safe-area-inset-bottom
    >
      <div class="popup-cont">
        <div class="popup-title">
          {{ title }}
        </div>
        <div class="txt">编辑话术</div>
        <van-field
          v-model="content"
          rows="3"
          autosize
          label=""
          type="textarea"
        />
      </div>
      <div class="btn" @click="sendPersonal(null)">发送</div>
    </van-popup>
    <!-- 水印 -->
    <vue-watermark
      :text="watermarkText"
      :font-size="16"
      :line-height="24"
      :width="100"
      :height="60"
      :angle="-15"
      :opacity="0.1"
    />
    <!-- 删除面板 -->
    <van-action-sheet
      v-model="showDelete"
      :actions="[{ name: '删除', color: 'red' }]"
      cancel-text="取消"
      description="删除话术？"
      close-on-click-action
      @select="selectDelete"
      @cancel="showDelete = false"
    />
  </div>
</template>

<script>
import "@vant/touch-emulator";
import {
  groupListApi,
  groupStandardApi,
  personalListApi,
  tagGroupListApi,
  delPersonalApi,
} from "@/api/modules/speechbank";
import { addForwardRecordApi } from "@/api/modules/material";
import wxSDK from "@/scripts/wxsdk";
import { getWechatEnv, browseEvent, pageClickEvent } from "@/utils/utils";
import VueWatermark from "vue-watermark";
import { Toast } from "vant";
import dayjs from "dayjs";

export default {
  name: "Speechbank",
  components: {
    VueWatermark,
  },
  props: {
    isWorkbenches: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      channel: getWechatEnv(), // 企微1 微信2
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      active: "standard", // tabs
      showOverlay: false, // 遮层
      groupList: [], // 话术分组列表
      groupId: "", // 话术分组id
      showPopup: false, // 标准话术编辑框
      id: "",
      title: "", // 标准话术标题
      content: "", // 标准话术内容
      pageIndex: 1,
      pageSize: 10,
      keyWord1: "", // 搜索内容
      keyWord2: "", // 搜索内容
      loading: false,
      finished: false,
      standardList: [],
      personalList: [],
      groupIdList: [], // 选中的分组id
      watermarkText: "",
      tabActive: 0, // 0分组 1标签
      tagList: [], // 话术标签列表
      tagIdList: [], // 话术标签id列表
      showDelete: false, // 删除面板
      deleteItem: null,
      startTime: dayjs(), // 开始时间
      page_url: window.location.href, // 页面链接
      page_id: window.location.pathname, // 页面唯一标识
    };
  },
  watch: {
    active(newValue, oldValue) {
      if (newValue === "person") {
        // 埋点 浏览结束
        browseEvent({
          tab_name: "话术", // tab名称
          page_name: "标准话术库", // 页面名
          page_url: this.page_url, // 页面链接
          page_id: this.page_id, // 页面唯一标识
          end_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
          view_time: dayjs().diff(this.startTime, "second"), // 页面停留时长
        });
        // 埋点 浏览开始
        browseEvent({
          tab_name: "话术", // tab名称
          page_name: "个人话术库", // 页面名
          page_url: this.page_url, // 页面链接
          page_id: this.page_id, // 页面唯一标识
          start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
        });
      }
      if (newValue === "standard") {
        // 埋点 浏览结束
        browseEvent({
          tab_name: "话术", // tab名称
          page_name: "个人话术库", // 页面名
          page_url: this.page_url, // 页面链接
          page_id: this.page_id, // 页面唯一标识
          end_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
          view_time: dayjs().diff(this.startTime, "second"), // 页面停留时长
        });
        // 埋点 浏览开始
        browseEvent({
          tab_name: "话术", // tab名称
          page_name: "标准话术库", // 页面名
          page_url: this.page_url, // 页面链接
          page_id: this.page_id, // 页面唯一标识
          start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
        });
      }
    },
  },
  async created() {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (userInfo) {
      this.watermarkText = `${userInfo.name}${userInfo.userId.slice(-4)}`;
    }
    const speechActive = sessionStorage.getItem("speechActive");
    if (speechActive) {
      this.active = speechActive;
      sessionStorage.removeItem("speechActive");
    }
    this.getALLGroup();
    this.getSriptLibrary();
    this.getPersonalList();
    this.getTagGroupList();
    await wxSDK.config(
      ["sendChatMessage", "shareToExternalContact"],
      ["sendChatMessage", "shareToExternalContact"]
    );
  },
  activated() {
    this.getPersonalList();
  },
  mounted() {
    // 埋点 浏览开始
    browseEvent({
      tab_name: "话术", // tab名称
      page_name: "标准话术库", // 页面名
      page_url: this.page_url, // 页面链接
      page_id: this.page_id, // 页面唯一标识
      start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
    });
  },
  methods: {
    // 获取标准话术列表
    async getSriptLibrary() {
      this.loading = true;
      const res = await groupStandardApi({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        keyWord: this.keyWord1,
        groupIdList: this.groupIdList,
        tagList: this.tagIdList,
      });
      if (res.code === 0) {
        this.standardList = this.standardList.concat(res.data.dataList);
        this.loading = false;

        if (res.data.dataList.length < 10) {
          this.finished = true;
        }
      }
    },
    // 加载标准化话术
    onLoad() {
      this.pageIndex++;
      this.getSriptLibrary();
    },
    // 搜索标准话术
    onSearch() {
      this.pageIndex = 1;
      this.standardList = [];
      this.finished = false;
      this.getSriptLibrary();
    },
    // 打开筛选 popup
    onOpenFilter() {
      this.showOverlay = !this.showOverlay;
    },
    // 点击遮层
    handleOverlay() {
      this.showOverlay = false;
    },
    // 编辑标准话术
    editStandard(item) {
      this.id = item.id;
      this.title = item.title;
      this.content = item.content;
      this.showPopup = true;
      // 埋点 标准话术编辑
      pageClickEvent({
        button_name: "标准话术编辑", // 按钮名称
        platform_id: this.id, // 话术ID
        platform_name: this.title, // 话术名称
        platform_type: "标准", // 话术类型
        page_id: this.page_id, // 页面唯一标识
        page_url: this.page_url, // 页面链接
        page_name: "话术库", // 页面名
        tab_name: "话术", // tab名称
      });
    },
    // 获取全部话术分组
    async getALLGroup() {
      const res = await groupListApi({
        catId: "5",
      });
      if (res.code === 0) {
        this.groupList = res.data;
      }
    },
    // 切换分组标签
    checkGroup(item) {
      // 埋点 话术分组
      pageClickEvent({
        button_name: "话术分组", // 按钮名称
        tag_id: item.groupId, // 标签id
        tag_name: item.groupName, // 标签名称
        page_id: this.page_id, // 页面唯一标识
        page_url: this.page_url, // 页面链接
        page_name: "话术库", // 页面名
        tab_name: "话术", // tab名称
      });
      if (this.groupIdList.includes(item.groupId)) {
        this.groupIdList = this.groupIdList.filter(
          (item) => item !== item.groupId
        );
      } else {
        this.groupIdList = [...this.groupIdList, item.groupId];
      }
      this.pageIndex = 1;
      this.standardList = [];
      this.finished = false;
      this.getSriptLibrary();
    },
    // 选择标签
    checkTag(item) {
      // 埋点 话术标签
      pageClickEvent({
        button_name: "话术标签", // 按钮名称
        tag_id: item.tagId, // 标签id
        tag_name: item.tagName, // 标签名称
        page_id: this.page_id, // 页面唯一标识
        page_url: this.page_url, // 页面链接
        page_name: "话术库", // 页面名
        tab_name: "话术", // tab名称
      });
      if (this.tagIdList.includes(item.tagId)) {
        this.tagIdList = this.tagIdList.filter((item) => item !== item.tagId);
      } else {
        this.tagIdList = [...this.tagIdList, item.tagId];
      }
      this.pageIndex = 1;
      this.standardList = [];
      this.finished = false;
      this.getSriptLibrary();
    },
    // 获取个人话术列表
    async getPersonalList() {
      const res = await personalListApi({
        keyWord: this.keyWord2,
      });
      if (res.code === 0) {
        this.personalList = res.data;
      }
    },
    // 编辑个人话术
    goEdit(item) {
      this.$router.push(`/createAndEdit?id=${item.id}`);
      sessionStorage.setItem("personalItem", JSON.stringify(item));
    },
    // 发送话术
    async sendPersonal(data) {
      if (data) {
        if (this.active === "standard") {
          // 埋点 标准 话术转发
          pageClickEvent({
            button_name: "话术转发", // 按钮名称
            platform_id: data.id, // 话术ID
            platform_name: data.title, // 话术名称
            platform_type: "标准", // 话术类型
            page_id: this.page_id, // 页面唯一标识
            page_url: this.page_url, // 页面链接
            page_name: "话术库", // 页面名
            tab_name: "话术", // tab名称
          });
        } else {
          // 埋点 个人 话术转发
          pageClickEvent({
            button_name: "话术转发", // 按钮名称
            platform_id: data.id, // 话术ID
            platform_name: data.title, // 话术名称
            platform_type: "个人", // 话术类型
            page_id: this.page_id, // 页面唯一标识
            page_url: this.page_url, // 页面链接
            page_name: "话术库", // 页面名
            tab_name: "话术", // tab名称
          });
        }
        if (this.isWorkbenches) {
          // 知识库入口
          await wxSDK.speechBankForwarding(data.content);
        } else {
          await wxSDK.sendChatMessage("text", {
            content: data.content,
          });
        }
        // 新增转发记录
        await addForwardRecordApi({
          sourceId: data.id,
          sourceName: data.title,
          sourceType: 2,
          channel: 2,
        });
      } else {
        if (this.isWorkbenches) {
          // 知识库入口
          await wxSDK.speechBankForwarding(this.content);
        } else {
          await wxSDK.sendChatMessage("text", {
            content: this.content,
          });
        }
        await addForwardRecordApi({
          sourceId: this.id,
          sourceName: this.title,
          sourceType: 2,
          channel: 2,
        });
      }
    },
    // 搜索个人话术列表
    onSearchPersonal(value) {
      this.keyWord2 = value;
      this.getPersonalList();
    },
    // 清空个人话术搜索
    onClearPersonal() {
      this.keyWord2 = "";
      this.getPersonalList();
    },
    // 获取话术标签
    async getTagGroupList() {
      const res = await tagGroupListApi({
        appId: 10001,
        catId: 5,
      });
      console.log(res);
      if (res.code === 0) {
        this.tagList = res.data;
      }
    },
    // 重置标签
    resetTags() {
      if (this.groupIdList.length > 0) {
        this.groupIdList = [];
      }
      if (this.tagIdList.length > 0) {
        this.tagIdList = [];
      }
      this.pageIndex = 1;
      this.finished = false;
      this.standardList = [];
      this.getSriptLibrary();
    },
    // 打开删除个人话术库面板
    deletePersonal(item) {
      this.deleteItem = item;
      this.showDelete = true;
    },
    // 删除个人话术库
    async selectDelete() {
      const res = await delPersonalApi({
        id: this.deleteItem.id,
      });

      if (res.code === 0) {
        Toast.success("删除成功");
        // 埋点 个人话术删除
        pageClickEvent({
          button_name: "个人话术删除", // 按钮名称
          platform_id: this.deleteItem.id, // 话术ID
          platform_name: this.deleteItem.title, // 话术名称
          platform_type: "个人", // 话术类型
          page_id: this.page_id, // 页面唯一标识
          page_url: this.page_url, // 页面链接
          page_name: "话术库", // 页面名
          tab_name: "话术", // tab名称
        });
        this.getPersonalList();
      }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.speechapp {
  width: 100%;
  height: 100vh;
  ::v-deep .van-tabs__wrap {
    height: 40px;
    .van-tabs__nav {
      z-index: 9;
    }
  }
  .standard {
    width: 100%;
    height: calc(100% - 40px);
    .head {
      position: relative;
      padding-top: 40px;
      .search-box {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 40px;
        padding: 4px 12px;
        background-color: #fff;
        z-index: 9;
        .left {
          position: relative;
          flex: 1;
          margin-right: 12px;
          ::v-deep .van-search {
            width: 100%;
            height: 32px;
            background: #f8f8f8;
            border-radius: 30px;
            .van-field__left-icon {
              img {
                width: 20px;
                height: 20px;
              }
            }
            .van-search__content {
              padding-left: 0;
            }
            .van-field {
              display: flex;
              align-items: center;
              line-height: 1;
            }
          }
        }
      }
      .popup-tags {
        position: absolute;
        top: 39px;
        left: 0;
        width: 100%;
        max-height: 400px;
        z-index: 9;
        background-color: #fff;
        padding: 5px 20px 15px;
        border-radius: 0 0 10px 10px;
        overflow-y: hidden;
        .tag-item {
          &:last-child {
            .tag-cont {
              margin-bottom: 0;
            }
          }
          .tag-cont {
            margin-bottom: 12px;
          }
        }
        .tags-title {
          font-weight: 500;
          font-size: 13px;
          color: #333333;
          margin-bottom: 10px;
          cursor: pointer;
        }
        .tags-list {
          display: flex;
          flex-wrap: wrap;
          .tags-item {
            height: 24px;
            background: #f7f7f7;
            border-radius: 2px 2px 2px 2px;
            padding: 5px 10px;
            margin-right: 10px;
            margin-bottom: 8px;
            font-size: 12px;
            color: #666666;
            text-align: center;
            border: 1px solid #fff;
            cursor: pointer;
          }
          .act {
            border: 1px solid #4d4d4d;
            color: #333333;
          }
        }
        ::v-deep .van-tabs {
          height: 380px;
          overflow-y: hidden;
          .van-tabs__wrap {
            width: 128px;
            height: 32px;
          }
          .van-tabs__content {
            height: 330px;
            padding-top: 10px;
            overflow-y: auto;
          }
        }
        .reset {
          position: absolute;
          top: 12px;
          right: 20px;
          font-size: 14px;
          color: #007ad3;
          z-index: 9;
          cursor: pointer;
        }
      }
    }
    .cont {
      width: 100%;
      height: calc(100% - 40px);
      padding: 10px 12px 44px;
      overflow: auto;
      .speech-item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        padding: 15px;
        border-bottom: 1px dashed #e5e5e5;
        cursor: pointer;
        &:last-child {
          border-bottom: 0;
        }
        .title {
          font-weight: 500;
          font-size: 15px;
          color: #333333;
          margin-bottom: 8px;
        }
        .txt {
          font-size: 14px;
          color: #666666;
          line-height: 20px;
          margin-bottom: 8px;
        }
        .bot {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .num {
            font-size: 12px;
            color: #999999;
          }
          .btn {
            width: 54px;
            height: 25px;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #f26147;
            font-size: 12px;
            color: #f26147;
            text-align: center;
            line-height: 24px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .person {
    width: 100%;
    height: calc(100% - 40px);
    position: relative;
    .head {
      position: relative;
      padding-top: 40px;
      .search-box {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 40px;
        padding: 4px 12px;
        background-color: #fff;
        z-index: 9;
        .van-search {
          width: 100%;
          height: 32px;
          background: #f8f8f8;
          border-radius: 30px;
          .van-field__left-icon {
            img {
              width: 20px;
              height: 20px;
            }
          }
          .van-search__content {
            padding-left: 0;
          }
          .van-field {
            display: flex;
            align-items: center;
            line-height: 1;
          }
        }
      }
    }
    .cont {
      width: 100%;
      height: calc(100% - 40px);
      padding: 10px 12px 44px;
      overflow: auto;
      .person-item {
        display: flex;
        flex-direction: column;
        width: 100%;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #f2f2f2;
        padding: 15px;
        margin-bottom: 10px;
        cursor: pointer;
        .title {
          font-weight: 500;
          font-size: 15px;
          color: #333333;
          margin-bottom: 8px;
        }
        .txt {
          font-size: 14px;
          color: #666666;
          line-height: 20px;
          margin-bottom: 12px;
        }
        .bot {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .btn {
            width: 54px;
            height: 25px;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #f26147;
            font-size: 12px;
            color: #f26147;
            text-align: center;
            line-height: 24px;
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
    }
    .create-btn {
      position: absolute;
      width: 66px;
      height: 66px;
      right: 18px;
      bottom: 50px;
      cursor: pointer;
    }
  }
  ::v-deep .van-popup {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 20px 32px;
    .popup-cont {
      margin-bottom: 10px;
      .popup-title {
        font-weight: 500;
        font-size: 16px;
        color: #3d3d3d;
        margin-bottom: 24px;
      }
      .txt {
        font-size: 14px;
        color: #333333;
        margin-bottom: 8px;
      }
      .van-field {
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #f2f2f2;
        padding: 0;
        .van-field__control {
          height: 180px !important;
          padding: 10px 16px;
        }
      }
    }
    .btn {
      width: 100%;
      height: 42px;
      background: #f26147;
      border-radius: 8px 8px 8px 8px;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 42px;
      cursor: pointer;
    }
  }
}
</style>
